import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../../components/tables/tableContext/TableContext";
import { CargoNodeDataInterface } from "../../../../../../redux/interfaces/raports.interface";
import { getDateAndTime } from "../../../../../../utils/dateAndTime";

export const cargoTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Sn bin/AWB",
    value: "sn_bin",
    minW: 125,
  },
  {
    label: "Sofer",
    value: "sofer",
    minW: 125,
  },
  {
    label: "Ruta",
    value: "ruta",
    minW: 125,
  },
  {
    label: "Nod destinatie",
    value: "nod_destinatie_bin",
    minW: 125,
  },
  {
    label: "Punct de livrare",
    value: "pctLivrare_colet",
    minW: 125,
  },
  {
    label: "Tip",
    value: "tip",
    minW: 125,
  },
  {
    label: "Data incarcare",
    value: "data_incarcare",
    minW: 125,
  },
];

export const getCargoTableData = (
  data: CargoNodeDataInterface[],
): TableData[] =>
  data.map((item) => {
    const isColdBox = item.tip_ambalaj === 75;

    const coldBoxStyle = {
      color: isColdBox ? "#90D5FF" : "black",
    };

    return {
      id: item.id_transport_marfa,
      crudData: item,
      data: [
        {
          title: item.sn_bin ?? item.doc_trans ?? "-",
          titleStyle: coldBoxStyle,
        },
        {
          title: item.sofer,
        },
        {
          title: item.ruta,
        },
        {
          title: item.nod_destinatie_bin ?? item.nod_destinatie_colet ?? "-",
        },
        {
          title: item.pctLivrare_colet ?? "-",
        },
        {
          badges: [
            {
              badgeText: item.sn_bin ? "Bin" : "Colet",
              badgeColor: item.sn_bin ? "light-info" : "light-primary",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: getDateAndTime(item.data_incarcare),
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
